import { IsiDtoPlBusinessRequest, IsiDtoPlBusinessResponse, IsiDtoPlCheckBusinessResult } from "../../Dtos/Isilog.IsiComponent.IsiDataTransferObject.isiPlBusiness";
import { IIsiUIFlowResult } from "../Core/IIsiUIFlowResult";
import { IsiPresentationLogic } from "./IsiPresentationLogic";

export type ParamPlBusiness = {
    primaryKeyValues?: string;
    checkToDo?: boolean;
    codeAction?: string;
    codeTreatment?: string;
    infosOtherFieldsEntity?: any;
    infosEntity?: any;
};

export class IsiPlBusiness extends IsiPresentationLogic {

    constructor() {
        super("IsiPlCheckBusinessHandler");
    }
    /**
     *  vérifier les règles métier.
     * @param dto : 
     */
    CheckBusiness(dto: ParamPlBusiness): Promise<IsiDtoPlCheckBusinessResult> {
        return new Promise<IsiDtoPlCheckBusinessResult>((resolve, reject) => {

            let request = IsiDtoPlBusinessRequest.fromJS({
                codeTreatment: dto.codeTreatment,
                codeAction: dto.codeAction,
                checkToDo: dto.checkToDo,
                infosEntity: dto.infosEntity,
                infosOtherFieldsEntity: dto.infosOtherFieldsEntity,
                primaryKeyValues: dto.primaryKeyValues,
                response: IsiDtoPlBusinessResponse.fromJS({
                })
            });

            this.ajaxWithErrorHandling("GetCheckBusiness", request, true).then((flow) => {
                if (flow.result) {
                    resolve(flow.reponse.response.getCheckBusinessResult);
                } else {
                    reject(flow.reponse);
                }
            })     
        });
    }
    /**
     *  vérifier les règles métier.
     * @param dto : 
     */
    SetBusinessData(dto: ParamPlBusiness): Promise<IIsiUIFlowResult> {
        return new Promise<IIsiUIFlowResult>((resolve, reject) => {

            let request = IsiDtoPlBusinessRequest.fromJS({
                infosOtherFieldsEntity: dto.infosOtherFieldsEntity,
                response: IsiDtoPlBusinessResponse.fromJS({
                })
            });
            this.ajaxWithErrorHandling("SetBusinessData", request, true).then((flow) => {
                resolve(flow);
            });
        });
    }
}
